export default __webpack_public_path__ + "static/media/of_0.61305db4.mp3";